import { modifier } from 'constant'
import { useEvent } from 'hooks'
import { cn } from 'utils'

import { constant } from './constant'
import { selectors } from './selector'

export const Activator = (() => {
	const handleAction = (scope: HTMLElement) => {
		const click = useEvent(scope, 'click')
		const id = scope.getAttribute(constant.selector.handler)
		if (!id) return

		const target = selectors.getTarget(id)
		if (!target) return

		click.register(() => {
			handleActiveClass(target, scope)
		})
	}
	const rotateBlocks = () => {
		const handlers = selectors.getAllHandlers()

		for (let i = 0, { length } = handlers; i < length; i++) {
			const handler = handlers[i]

			const id = handler.getAttribute(constant.selector.handler)
			if (!id) continue

			const target = selectors.getTarget(id)
			if (!target) continue

			handleActiveClass(target, handler)
		}
	}

	const handleActiveClass = (target: HTMLElement, handler: HTMLElement) => {
		if (cn.hasClass(target, modifier.active)) {
			cn.removeClass(target, modifier.active)
			cn.removeClass(handler, modifier.active)
		} else {
			cn.addClass(target, modifier.active)
			cn.addClass(handler, modifier.active)
		}
	}

	const handleFullPage = (scope: HTMLElement) => {
		const click = useEvent(scope, 'click')
		click.register(() => {
			rotateBlocks()
		})
	}

	const initHandlers = () => {
		const handlers = selectors.getAllHandlers()
		const fullPageHandler = selectors.getFullPageHandler()

		if (fullPageHandler) {
			handleFullPage(fullPageHandler)

			for (let i = 0, { length } = handlers; i < length; i++) {
				const handler = handlers[i]
				cn.addClass(handler, 'hidden')
			}

			if (handlers.length === 0) {
				cn.addClass(fullPageHandler, 'hidden')
			}
		} else if (handlers) {
			for (let i = 0, { length } = handlers; i < length; i++) {
				const handler = handlers[i]
				handleAction(handler)
			}
		}
	}

	const init = () => {
		initHandlers()
	}

	return {
		init,
	}
})()
